import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';

/**
 * Informs the user if errors exist on the delivery/sets they're trying to submit.
 */
@Component({
    selector: 'app-submit-dialog',
    templateUrl: './submit-dialog.component.html',
    styleUrls: ['./submit-dialog.component.css'],
    standalone: false
})
export class SubmitDialogComponent implements OnInit {

  finalSubmit: boolean = false;
  canSubmit: boolean = false;
  offline = this.onlineStatusService.getStatus() == OnlineStatusType.OFFLINE;

  constructor(public dialogRef: MatDialogRef<SubmitDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: boolean, public onlineStatusService: OnlineStatusService) { }

  ngOnInit(): void {
    this.canSubmit = !this.data;
  }

}
